import { gsap } from 'gsap/all'
import { SplitText } from 'gsap/SplitText'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ENV } from '../config'

const DEFAULT_DURATION = ENV.REDUCED_MOTION ? 0 : 0.5
const DEFAULT_EASE = 'power3.out'

// GSAP defaults
gsap.defaults({
    duration: DEFAULT_DURATION,
    ease: DEFAULT_EASE,
})

// Register plugins
gsap.registerPlugin(ScrollTrigger, SplitText)

export * from 'gsap'
export {
    DEFAULT_DURATION,
    DEFAULT_EASE,
    gsap,
    ScrollTrigger,
    SplitText
}
